import _ from 'lodash';

const processStrategy = (deviceEvent) => {
  const relations = {};
  const omit = [];
  return {
    ..._.omit(deviceEvent, omit),
    ..._.pickBy(relations, _.identity),
  };
};

export default {
  key: 'deviceEvent',
  definition: {},
  processStrategy,
};
